import React, { useState, useContext, useRef, useEffect } from "react";
//import { Button } from "@mui/material";
import { DashboardContext } from "../../../context/DashboardContext";
import "./tutorial.scss";
import CustomButton from "../../commonComponents/CustomButton";
import Modal from "react-modal";
import SsidChartIcon from "@mui/icons-material/SsidChart";

function Tutorial() {
  const { setTutorialOpen, setTutorialWelcomeModalOpen } =
    useContext(DashboardContext);

  const [runningTutorial, setRunningTutorial] = useState(0);
  const [localTutorialModalOpen, setLocalTutorialModalOpen] = useState(false);
  const tutorial1ButtonRef = useRef(null);
  const tutorialRef = useRef(null);

  // Calculate modal position based on tutorial step
  const getModalStyle = () => {
    const baseStyle = {
      width: "400px",
      height: "auto",
      minHeight: "150px",
      left: "auto",
      marginRight: "0",
      transform: "none",
      zIndex: "9999",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      padding: "20px",
      borderRadius: "8px",
      backgroundColor: "#f0f8ff",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      transition: "all 0.3s ease", // Transition all properties
    };

    // Position at top right for step 1, bottom right for step 2
    if (runningTutorial === 2 || runningTutorial === 3) {
      return {
        ...baseStyle,
        top: "auto",
        bottom: "80px",
        right: "50px",
      };
    } else if (
      runningTutorial === 8 ||
      runningTutorial === 9 ||
      runningTutorial === 10 ||
      runningTutorial === 11
    ) {
      return {
        ...baseStyle,
        top: "auto",
        bottom: "80px",
        left: "50px",
      };
    } else {
      return {
        ...baseStyle,
        top: "100px",
        bottom: "auto",
        right: "50px",
      };
    }
  };

  function handleStartTutorial1() {
    setRunningTutorial(1);
    setTutorialOpen(true);
    setLocalTutorialModalOpen(true);
    setTutorialWelcomeModalOpen(true);
  }

  const handleCloseTutorialModal = () => {
    setRunningTutorial(0);
    setLocalTutorialModalOpen(false);
    setTutorialWelcomeModalOpen(false);
  };

  // Add an effect to monitor data manager interactions
  useEffect(() => {
    // This is a public API to expose a way to close the welcome modal
    window.closeTutorialModal = handleCloseTutorialModal;

    // Also expose a way to check tutorial status and update it
    window.checkAndUpdateTutorial = (input) => {
      if (
        localTutorialModalOpen &&
        runningTutorial === 1 &&
        input === "DataManager"
      ) {
        setRunningTutorial(2);
        return true;
      } else if (
        localTutorialModalOpen &&
        runningTutorial === 2 &&
        input === "FileProcessing"
      ) {
        setRunningTutorial(3);
        return true;
      } else if (
        localTutorialModalOpen &&
        runningTutorial === 3 &&
        input === "DataLoaded"
      ) {
        setRunningTutorial(4);
        return true;
      } else if (
        localTutorialModalOpen &&
        runningTutorial === 4 &&
        input === "DataDisplayed"
      ) {
        setRunningTutorial(5);
        return true;
      } else if (
        localTutorialModalOpen &&
        runningTutorial === 5 &&
        input === "SetGraphRange"
      ) {
        setRunningTutorial(6);
        return true;
      } else if (
        localTutorialModalOpen &&
        runningTutorial === 6 &&
        input === "ExperimentSelection"
      ) {
        setRunningTutorial(7);
        return true;
      } else if (
        localTutorialModalOpen &&
        runningTutorial === 7 &&
        input === "ModelCreated"
      ) {
        setRunningTutorial(8);
        return true;
      } else if (
        localTutorialModalOpen &&
        runningTutorial === 8 &&
        input === "ModelDisplayed"
      ) {
        setRunningTutorial(9);
        return true;
      } else if (
        localTutorialModalOpen &&
        runningTutorial === 9 &&
        input === "AutoFit"
      ) {
        setRunningTutorial(10);
        return true;
      } else if (
        localTutorialModalOpen &&
        runningTutorial === 10 &&
        input === "AutoFitResponse"
      ) {
        setRunningTutorial(11);
        return true;
      }
      return false;
    };

    return () => {
      // Clean up when component unmounts
      delete window.closeTutorialModal;
      delete window.checkAndUpdateTutorial;
    };
  }, [localTutorialModalOpen, runningTutorial]);

  return (
    <div className="tutorial" ref={tutorialRef}>
      <div className="text">Available tutorials:</div>
      <div className="buttonsContainer">
        <div className="buttonSection">
          <div className="buttonWithText" ref={tutorial1ButtonRef}>
            <CustomButton
              text="Tutorial 1"
              extraClassnames={["tutorialVersion"]}
              handleClick={() => handleStartTutorial1()}
              id="tutorial-1"
            />
            {/* <Button
              variant="contained"
              size="small"
              sx={{ m: 1 }}
              onClick={() => handleButton1Click()}
              className="button"
              id="load-example-data"
              disabled={isFitOngoing || isLoopOngoing}
            >
              Step 1
            </Button> */}
            <div className="text">
              Analysis of a Raman spectrum (beginner level).
            </div>
          </div>
        </div>
      </div>

      {/* Welcome Modal */}
      <Modal
        isOpen={localTutorialModalOpen}
        onRequestClose={handleCloseTutorialModal}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        appElement={tutorialRef.current}
        ariaHideApp={false}
        style={{
          content: getModalStyle(),
          overlay: {
            backgroundColor: "transparent",
            zIndex: "9999",
            pointerEvents: "none",
          },
        }}
        contentLabel="Welcome to Tutorial"
        portalClassName="tutorial-modal-portal"
      >
        <div
          className="tutorial-modal-content"
          style={{
            pointerEvents: "auto",
          }}
        >
          <div className="tutorial-welcome-modal-title">
            Welcome to the app.speqqle tutorial!
          </div>
          <div className="tutorial-welcome-modal-text">
            You can always close the tutorial mode by clicking on the{" "}
            <b>Tutorial</b> button in the top bar.
          </div>
          {runningTutorial === 1 && (
            <div className="tutorial-welcome-modal-tutorial-title">
              Part 1: Data
            </div>
          )}
          {runningTutorial === 1 && (
            <div className="tutorial-welcome-modal-tutorial-text">
              Start your analysis by loading in your data:
              <ol>
                <li>
                  Open the <b>Data</b> tab in the tab selector
                </li>
                <li>
                  Click on <b>Data Manager</b>
                </li>
              </ol>
            </div>
          )}
          {runningTutorial === 2 && (
            <div className="tutorial-welcome-modal-tutorial-title">
              Part 1: Data Manager{" "}
            </div>
          )}
          {runningTutorial === 2 && (
            <div className="tutorial-welcome-modal-tutorial-text">
              You are now in the Data Manager. Select the tutorial data to
              continue.
              <ol>
                <li>
                  Click on the <b>Tutorial Data</b> button.
                </li>
              </ol>
              <br />
              <b>Extra information:</b>
              <br />
              In the <b>Data Manager</b> you can load in your data. In the{" "}
              <b>File Queue</b> section, on the left side, you can select your
              files using the <b>File</b> or <b>Folder</b> button. The{" "}
              <b>Tutorial Data</b> button is only available during tutorials.
            </div>
          )}
          {runningTutorial === 3 && (
            <div className="tutorial-welcome-modal-tutorial-title">
              Part 1: Data Processing and Loading{" "}
            </div>
          )}
          {runningTutorial === 3 && (
            <div className="tutorial-welcome-modal-tutorial-text">
              The tutorial data is now displayed in the file queue. To load the
              selected data:
              <ol>
                <li>
                  Click on the <b>Apply</b> or <b>Apply All</b> button.
                </li>
              </ol>
              <br />
              <b>Extra information:</b>
              <br />
              The top section shows the first entries of your raw data as well
              as of the processed/pre-loaded data. In case of incorrect
              processing, the <b>Data Loading Options</b> can be changed
              manually. You can specify the units of your data, select different
              collumns of your datafile for processing, and shift or scale the
              data curve. To easily reuse your <b>Data Loading Options</b>, you
              can save them as presets with the <b>Save as Presets</b> button.
              The tutorial data sould be processed with the default parameters.
            </div>
          )}
          {runningTutorial === 4 && (
            <div className="tutorial-welcome-modal-tutorial-title">
              Part 1: Data Display{" "}
            </div>
          )}
          {runningTutorial === 4 && (
            <div className="tutorial-welcome-modal-tutorial-text">
              Once the tutorial data is loaded, it is listed in the <b>Data</b>{" "}
              tab. To display the data in the graph:
              <ol>
                <li>
                  Click on the curves icon{" "}
                  <SsidChartIcon
                    style={{ fontSize: "1.2rem", verticalAlign: "middle" }}
                  />{" "}
                  of the graph.
                </li>
                <li>
                  Click on <b>Add Curves</b>
                </li>
                <li>
                  Select the tutorial data from the <b>From Files:</b> section.
                </li>
                <li>
                  Click anywhere outside the curve selection window to close it.
                </li>
              </ol>
              <br />
              <b>Extra information:</b>
              <br />
              Clicking on the file name in the data list opens the{" "}
              <b>Data Processing</b> window. Here you can change the units of
              your data, and exclude data by changing the <b>Data Range</b> or
              by adding <b>Exclusion Ranges</b>. The number of remaining
              datapoints is listed. Excluded data points will not be displayed
              in the graphs and will not be taking inro account for analysis and
              fitting. However, they are not deleted and can be simply
              redisplayed by changing the exclusion options. The{" "}
              <b>Data Processing</b> window can also be opened by clicking on
              the file name in the graph legend.
            </div>
          )}
          {runningTutorial === 5 && (
            <div className="tutorial-welcome-modal-tutorial-title">
              Part 1: Graph Display
            </div>
          )}
          {runningTutorial === 5 && (
            <div className="tutorial-welcome-modal-tutorial-text">
              To better display the data, change the graph y-axis range to
              0-1000.
              <ol>
                <li>Click on the graph settings icon.</li>
                <li>Change the y-axis range to 0-1000.</li>
                <li>
                  Click on the <b>Apply</b> button.
                </li>
              </ol>
              <br />
              <b>Extra information:</b>
              <br />
              You can also change the axes by dragging the axes, but to continue
              this tutorial you need to use the settings menu.
            </div>
          )}
          {runningTutorial === 6 && (
            <div className="tutorial-welcome-modal-tutorial-title">
              Part 2: Experiment
            </div>
          )}
          {runningTutorial === 6 && (
            <div className="tutorial-welcome-modal-tutorial-text">
              The next step is to select the type of experiment you have
              performed, so you can analyse this data.
              <ol>
                <li>
                  Click on the <b>Experiment</b> tab.
                </li>
                <li>
                  Click on the <b>Add New Experiment</b> button.
                </li>
              </ol>
            </div>
          )}
          {runningTutorial === 7 && (
            <div className="tutorial-welcome-modal-tutorial-title">
              Part 2: Experiment Selection
            </div>
          )}
          {runningTutorial === 7 && (
            <div className="tutorial-welcome-modal-tutorial-text">
              You are now analysing Raman data:
              <ol>
                <li>
                  Select the <b>Raman</b> model.
                </li>
              </ol>
              <br />
              <b>Extra information:</b>
              <br />
              In the <b>Experiment</b> tab you can select the type of experiment
              you have done. This creates one or more models describing the
              physics of your experiment. If you have any app.speqqle
              experiments or RefFit models saved you can load them directly
              using the <b>Load Experiment</b> button. To start a new experiment
              click on the <b>Add New Experiment</b> button. The available
              experiments are explained in more details in the <b>Manual</b>.
              <br />
              <br />
              <b>Troubleshoot:</b>
              <br />
              If you don&apos;t see a list of experiments to choose from, try
              clicking on the <b>Add New Experiment</b> button again. If the
              problem persists refresh the application and try again. For any
              remaining issues contact us at:{" "}
              <a href="mailto:support@speqqle.com">support@speqqle.com</a>.
            </div>
          )}
          {runningTutorial === 8 && (
            <div className="tutorial-welcome-modal-tutorial-title">
              Part 2: Experiment Display
            </div>
          )}
          {runningTutorial === 8 && (
            <div className="tutorial-welcome-modal-tutorial-text">
              You&apos;ve created a Raman model. Now you can go to the{" "}
              <b>Parameters</b> tab to examine and adjust the model parameters.
              Display the model output in the same graph as the data:
              <ol>
                <li>
                  Click on the curves icon{" "}
                  <SsidChartIcon
                    style={{ fontSize: "1.2rem", verticalAlign: "middle" }}
                  />{" "}
                  of the graph.
                </li>
                <li>
                  Click on <b>Add Curves</b>
                </li>
                <li>
                  Select the new Raman model from the <b>From Models:</b> section.
                </li>
                <li>
                  Click anywhere outside the curve selection window to close it.
                </li>
              </ol>
              <br />
              <b>Extra information:</b>
              <br />
              In the <b>Experiment</b> tab, from the experiments list, you can
              manage your experiments. You can rename them, delete them, or if
              you have multiple experiments or models of the same type, you can
              link them, forcing them to become and stay identical. Linked
              models can always be unlinked.
              <br />
              The Raman model you&apos;ve created contains parameters that can
              be adjusted to fit your data. These parameters represent physical
              properties of your sample or settings of your experiment. In the{" "}
              <b>Parameters</b> tab, you can view and modify these parameters.
              Try adjusting different values to see how they affect the model
              curve. You can add oscillators to your model by clicking on the{" "}
              <b>+</b> icon that appears when hovering on the right side of the
              model table.
            </div>
          )}
          {runningTutorial === 9 && (
            <div className="tutorial-welcome-modal-tutorial-title">
              Part 3: Autofit
            </div>
          )}
          {runningTutorial === 9 && (
            <div className="tutorial-welcome-modal-tutorial-text">
              Now that you have loaded in your data and selected your
              experiment, it is time to fit your model parameters to the data.
              <ol>
                <li>
                  Click on the <b>AutoFit</b> button.
                </li>
              </ol>
              <br />
              <b>Extra information:</b>
              <br />
              To find the best model parameters to describe your data, you can
              change the parameter values manually. Once you have achieved an
              approximate match, you can use the fit option in the <b>
                Fit
              </b>{" "}
              tab to optimize the values. However, for Raman there is a quicker
              way. The <b>AutoFit</b> function automatically finds the best
              initial parameters and performs a fit. You can access the
              <b>AutoFit</b> function from the <b>AutoFit</b> button in a graph
              displaying a Raman model, or from any Raman model in the{" "}
              <b>Parameters</b> tab.
            </div>
          )}
          {runningTutorial === 10 && (
            <div className="tutorial-welcome-modal-tutorial-title">
              Part 3: Autofit Set-Up
            </div>
          )}
          {runningTutorial === 10 && (
            <div className="tutorial-welcome-modal-tutorial-text">
              Check that the correct data is selected to run the <b>AutoFit</b>{" "}
              against.
              <ol>
                <li>
                  Click on the <b>AutoFit</b> button.
                </li>
              </ol>
              <br />
              <b>Extra information:</b>
              <br />
              In the <b>AutoFit</b> window you can select the data that you want
              to use for the fit. You can exclude any data range you deem to be
              unreliable and/or choose to let the software do the remobal of the
              peak at zero frequency automatically. You can also provide a
              temperature estimate. If your data does not contain sufficient
              datapoints in both the negative and positive x-axis regions, a
              temperature estimate is necessary. For the tutorial data the
              default settings are sufficient. The <b>AutoFit</b> overwrites any
              existing model parameters or settings.
            </div>
          )}
          {runningTutorial === 11 && (
            <div className="tutorial-welcome-modal-tutorial-title">
              Part 3: Autofit Results
            </div>
          )}
          {runningTutorial === 11 && (
            <div className="tutorial-welcome-modal-tutorial-text">
              Congratulations! You have just fitted your first Raman sepctrum
              using app.speqqle and completed this tutorial. Your model
              parameters are displayed in the <b>Parameters</b> tab. You can
              check the ranges of excluded data by clicking on the data file
              name in the <b>Data</b> tab.
              <br />
              <br />
              <b>Possible next steps:</b>
              <br />
              <ol>
                <li>
                  <b>Save and Load Sessions:</b> You can save your session at
                  any time by clicking on the <b>Save</b> button in the top bar.
                  A saved session can be loaded by clicking on the <b>Load</b>{" "}
                  button.
                </li>
                <li>
                  <b>Perform a regular fit:</b> If you are unsatified with the
                  fit results, you can change any of the parameters manual, and
                  then perform a manual fit in the <b>Fit</b> tab.
                </li>
                <li>
                  <b>Export data:</b> You can export your model curves using the
                  export button in the graph.
                </li>
              </ol>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
}

export default Tutorial;
